<template>
  <div class="card" :class="cardClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PostCard',
  props: {
    noBody: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    cardClass() {
      const classes = [];
      if (this.variant) {
        classes.push(`bg-${this.variant}`);
      }
      return classes.join(' ');
    }
  }
};
</script>

<style scoped></style>